import router from '@/router'
import NProgress from '@/utils/nprogress'
import {getToken} from '@/utils/auth'

export function setupPermission() {
    const whiteList = ['/login']
    router.beforeEach((to, from, next) => {
        NProgress.start();
        const isLogin = !!getToken()
        if (isLogin) {
            // console.log('isLogin')
            if (to.path === '/login') {
                next({path: '/'})
            } else {
                next()
            }
        } else {
            // console.log('noLogin')
            if (whiteList.indexOf(to.path) !== -1) {
                next()
            } else {
                // next({path: '/login'})
                // 不在白名单，重定向到登录页
                redirectToLogin(to, next)
                NProgress.done() // 关闭进度条
            }
        }
    })

    // 后置守卫，保证每次路由跳转结束时关闭进度条
    router.afterEach(() => {
        NProgress.done()
    })
}

function redirectToLogin(to, next) {
    const params = new URLSearchParams(to.query)
    const queryString = params.toString()
    const redirect = queryString ? `${to.path}?${queryString}` : to.path
    next(`/login?redirect=${encodeURIComponent(redirect)}`)
}